import { ReactNode } from 'react';
import classNames from 'classnames';
import { m } from 'framer-motion';
import { useDelayedToggle } from '../../../hooks/useDelayedToggle';
import { ThemePopup } from '../../../context/theme/ThemeConstantsUpdated';

const { background, shadow, mainText } = ThemePopup;

export const Tooltip = (props: Props) => {
  const { children, tip, addTipPadding } = props;
  const { isToggled: isVisible, setIsToggled, handleMouseEnter, handleMouseLeave } = useDelayedToggle({});

  return (
    <div className="group relative flex flex-col items-center">
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={() => setIsToggled(false)}>
        {children}
      </div>
      {isVisible && (
        <m.div
          className={classNames(
            addTipPadding ? '-top-1' : 'top-0',
            'absolute top-0 z-50 mb-6 flex flex-col items-center group-hover:flex'
          )}
        >
          <span
            className={classNames(
              background,
              shadow,
              mainText,
              'absolute -top-1.5 z-20 -translate-y-full whitespace-nowrap rounded-md p-2 leading-none'
            )}
          >
            {tip}
          </span>

          <div className={classNames(background, shadow, 'absolute z-10 h-3.5 w-3.5 -translate-y-full rotate-45')} />

          <span
            className={classNames(
              background,
              mainText,
              'absolute -top-1.5 z-40 -translate-y-full whitespace-nowrap rounded-md p-2 leading-none'
            )}
          >
            {tip}
          </span>

          <div className={classNames(background, 'absolute z-30 h-3.5 w-3.5 -translate-y-full rotate-45')} />
        </m.div>
      )}
    </div>
  );
};

type Props = {
  tip: string;
  addTipPadding?: boolean;
  children: ReactNode;
};
